import * as React from 'react';
import { Text } from '@patternfly/react-core';
import UserInterface from '@app/Interface/UserInterface';

interface UserDisplayStatusProps {
    user: UserInterface;
}

const UserDisplayStatus: React.FC<UserDisplayStatusProps> = ({user}) => {

    let status = "Pending";

    if (user.confirmed) {
        status = "Active";
    }

    return (
        <Text>{status}</Text>
    );

}

export default UserDisplayStatus;